import { render } from "./index.vue?vue&type=template&id=35b40125&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=35b40125&scoped=true&lang=css"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b40125"],['__file',"resources/admin/ui/Pages/Products/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35b40125"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35b40125', __exports__)) {
    api.reload('35b40125', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=35b40125&scoped=true", () => {
    api.rerender('35b40125', render)
  })

}


export default __exports__